export { default as AddCategory } from './page';



// WEBPACK FOOTER //
// ./src/pages/systemAddCategory/index.js